import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
export const TermsOfService = () => {
  // Scroll to top on component mount
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="font-[Inter,ui-sans-serif,system-ui] text-[#0B1220] overflow-x-hidden relative bg-gradient-to-b from-[#f8faff] to-[#f0f5ff]" data-id="element-995">
      {/* Cinematic frame markers - subtle guides at the edges of the viewport */}
      <div className="fixed inset-x-0 top-0 h-[2px] bg-[#2E6BFF]/5 z-50" data-id="element-996"></div>
      <div className="fixed inset-x-0 bottom-0 h-[2px] bg-[#2E6BFF]/5 z-50" data-id="element-997"></div>
      <div className="fixed inset-y-0 left-0 w-[2px] bg-[#2E6BFF]/5 z-50" data-id="element-998"></div>
      <div className="fixed inset-y-0 right-0 w-[2px] bg-[#2E6BFF]/5 z-50" data-id="element-999"></div>
      {/* Dynamic background elements */}
      <div className="fixed inset-0 z-0 overflow-hidden pointer-events-none" data-id="element-1000">
        <div className="absolute top-0 right-0 w-[80vw] h-[80vh] rounded-full bg-gradient-to-b from-[#2E6BFF]/5 to-transparent opacity-40 blur-[120px]" data-id="element-1001"></div>
        <div className="absolute bottom-0 left-0 w-[70vw] h-[70vh] rounded-full bg-gradient-to-t from-[#36D1DC]/5 to-transparent opacity-40 blur-[100px]" data-id="element-1002"></div>
        <motion.div className="absolute top-1/4 left-1/4 w-[50vw] h-[50vh] rounded-full bg-gradient-to-r from-[#0BB489]/5 to-transparent opacity-30 blur-[80px]" animate={{
        x: [0, 20, 0],
        y: [0, -20, 0]
      }} transition={{
        duration: 20,
        repeat: Infinity,
        repeatType: 'reverse',
        ease: 'easeInOut'
      }} data-id="element-1003"></motion.div>
      </div>
      <Navbar data-id="element-1004" />
      <main className="relative z-10 pt-24 pb-16" data-id="element-1005">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1006">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} className="bg-white/80 backdrop-blur-sm rounded-2xl shadow-lg p-6 sm:p-8 border border-white/50" data-id="element-1007">
            <h1 className="text-3xl font-bold mb-6 text-[#0B1220]" data-id="element-1008">
              Terms of Service
            </h1>
            <p className="text-gray-600 mb-6" data-id="element-1009">
              Last updated: September 24, 2024
            </p>
            <div className="space-y-6 text-[#0B1220]" data-id="element-1010">
              <p data-id="element-1011">
                Welcome to Pigeon Documents Incorporated ("Pigeon Documents,"
                "we," "us," or "our"). By accessing or using the Services (as
                defined below), you agree to be bound by these Terms of Service
                ("Terms"). If you do not agree to these Terms, you may not
                access or use the Services.
              </p>
              <section data-id="element-1012">
                <h2 className="text-xl font-semibold mb-3 text-[#2E6BFF]" data-id="element-1013">
                  Description of Services
                </h2>
                <p data-id="element-1014">
                  Pigeon Documents provides an online platform that allows users
                  to upload, store, and share documents ("Services"). The
                  Services may be accessed through our website at
                  www.pigeondocuments.com.
                </p>
              </section>
              <section data-id="element-1015">
                <h2 className="text-xl font-semibold mb-3 text-[#2E6BFF]" data-id="element-1016">
                  Data Processing Agreement (DPA)
                </h2>
                <p className="mb-3" data-id="element-1017">
                  By using the Services provided by Pigeon Documents, you, as
                  the Data Controller, agree to the terms of this Data
                  Processing Agreement (DPA), which is incorporated into these
                  Terms of Service. This DPA governs the processing of personal
                  data, as defined by the General Data Protection Regulation
                  (GDPR) and other applicable data privacy regulations.
                </p>
                <div className="space-y-4 ml-4" data-id="element-1018">
                  <div data-id="element-1019">
                    <h3 className="font-medium mb-1" data-id="element-1020">1. Processing Purpose</h3>
                    <p data-id="element-1021">
                      Pigeon Documents processes personal data solely for the
                      purpose of providing, maintaining, and improving the
                      Services as outlined in the Terms of Service.
                    </p>
                  </div>
                  <div data-id="element-1022">
                    <h3 className="font-medium mb-1" data-id="element-1023">
                      2. Types of Personal Data
                    </h3>
                    <p data-id="element-1024">
                      The types of personal data processed may include contact
                      information, document metadata, login credentials, and
                      other personal information uploaded by users through the
                      platform.
                    </p>
                  </div>
                  <div data-id="element-1025">
                    <h3 className="font-medium mb-1" data-id="element-1026">
                      3. Data Controller Responsibilities
                    </h3>
                    <p data-id="element-1027">
                      As the Data Controller, you are responsible for ensuring
                      the legality, reliability, and integrity of the personal
                      data you provide. You must also obtain necessary consents
                      from your users or customers where required by law.
                    </p>
                  </div>
                  <div data-id="element-1028">
                    <h3 className="font-medium mb-1" data-id="element-1029">
                      4. Data Processor Responsibilities
                    </h3>
                    <p data-id="element-1030">
                      Pigeon Documents will only process data according to your
                      instructions and in accordance with this DPA. We implement
                      appropriate security measures to protect personal data and
                      will notify you in the event of a data breach.
                    </p>
                  </div>
                  <div data-id="element-1031">
                    <h3 className="font-medium mb-1" data-id="element-1032">5. Subprocessors</h3>
                    <p data-id="element-1033">
                      We may engage subprocessors to assist in the provision of
                      the Services. We will ensure that all subprocessors comply
                      with the same data protection obligations set out in this
                      DPA.
                    </p>
                  </div>
                  <div data-id="element-1034">
                    <h3 className="font-medium mb-1" data-id="element-1035">6. Data Transfers</h3>
                    <p data-id="element-1036">
                      If personal data is transferred outside the European
                      Economic Area (EEA), we will ensure that adequate
                      protections are in place, such as Standard Contractual
                      Clauses (SCCs) or equivalent mechanisms to comply with
                      GDPR.
                    </p>
                  </div>
                  <div data-id="element-1037">
                    <h3 className="font-medium mb-1" data-id="element-1038">7. Data Subject Rights</h3>
                    <p data-id="element-1039">
                      Pigeon Documents will assist you in responding to data
                      subject requests under GDPR, such as requests for access,
                      rectification, or erasure of personal data.
                    </p>
                  </div>
                  <div data-id="element-1040">
                    <h3 className="font-medium mb-1" data-id="element-1041">
                      8. Security and Breach Notification
                    </h3>
                    <p data-id="element-1042">
                      We maintain appropriate security measures to protect
                      personal data and will promptly notify you of any data
                      breaches affecting your data.
                    </p>
                  </div>
                </div>
              </section>
              <section data-id="element-1043">
                <h2 className="text-xl font-semibold mb-3 text-[#2E6BFF]" data-id="element-1044">
                  Fulfillment Policy
                </h2>
                <div className="space-y-4" data-id="element-1045">
                  <div data-id="element-1046">
                    <h3 className="font-medium mb-1" data-id="element-1047">
                      Service Delivery and Access
                    </h3>
                    <p data-id="element-1048">
                      Upon signing up for a free trial, customers will receive
                      immediate access to Pigeon Documents' trial features. The
                      trial lasts for 14 days, during which customers can
                      explore all functionalities available within the trial
                      plan.
                    </p>
                    <p className="mt-2" data-id="element-1049">
                      For clients transitioning to a paid subscription, access
                      to premium features will be provided within 24-48 hours
                      after the payment of the issued invoice is processed.
                      Invoices are sent based on the terms agreed upon in the
                      subscription plan, and timely payment is required to
                      maintain continued access to premium services.
                    </p>
                  </div>
                  <div data-id="element-1050">
                    <h3 className="font-medium mb-1" data-id="element-1051">Cancellation Policy</h3>
                    <p data-id="element-1052">
                      Customers may cancel their subscription at any time during
                      the trial period without incurring any charges. For paid
                      subscriptions, cancellations can be made prior to the next
                      billing cycle by contacting our support team at
                      support@pigeondocuments.com. Cancellations will take
                      effect at the end of the current billing cycle, and no
                      further charges will be made.
                    </p>
                  </div>
                  <div data-id="element-1053">
                    <h3 className="font-medium mb-1" data-id="element-1054">Refund Policy</h3>
                    <p data-id="element-1055">
                      All payments made for paid subscriptions are
                      non-refundable unless otherwise specified in the terms of
                      a signed agreement or explicitly stated in the invoice.
                      Refunds may only be granted in exceptional circumstances,
                      such as billing errors or if service access was not
                      provided as outlined in the agreement or invoice. If you
                      believe there has been an error with your invoice or
                      subscription, please contact our support team at
                      support@pigeondocuments.com, and we will work to resolve
                      the issue on a case-by-case basis.
                    </p>
                  </div>
                  <div data-id="element-1056">
                    <h3 className="font-medium mb-1" data-id="element-1057">
                      Support for Access Issues
                    </h3>
                    <p data-id="element-1058">
                      If you encounter any issues accessing the service after
                      making payment, please contact our support team
                      immediately at support@pigeondocuments.com, and we will
                      assist in resolving the problem as quickly as possible.
                    </p>
                  </div>
                </div>
              </section>
              <section data-id="element-1059">
                <h2 className="text-xl font-semibold mb-3 text-[#2E6BFF]" data-id="element-1060">
                  Your Account
                </h2>
                <p className="mb-3" data-id="element-1061">
                  In order to use the Services, you must create an account. When
                  you create an account, you agree to provide accurate and
                  complete information. You are responsible for maintaining the
                  confidentiality of your account and password, and you are
                  responsible for all activities that occur under your account.
                  You agree to notify us immediately of any unauthorized use of
                  your account or password. We will not be liable for any loss
                  or damage arising from your failure to comply with this
                  requirement.
                </p>
                <p data-id="element-1062">
                  You may not use another person's account without their
                  permission. You may not create multiple accounts for the
                  purpose of abusing the system or evading suspension or
                  termination of your account.
                </p>
              </section>
              <section data-id="element-1063">
                <h2 className="text-xl font-semibold mb-3 text-[#2E6BFF]" data-id="element-1064">
                  Data Privacy and User Rights
                </h2>
                <p className="mb-3" data-id="element-1065">
                  By using Pigeon Documents, you agree to our Privacy Policy,
                  which governs how we collect, use, and disclose your personal
                  data. This includes your rights as a data subject under
                  applicable privacy laws, such as the General Data Protection
                  Regulation (GDPR).
                </p>
                <p data-id="element-1066">
                  You can exercise your data rights, including requesting access
                  to your personal information, objecting to data processing, or
                  requesting data erasure, by contacting us at
                  support@pigeondocuments.com. More details about your rights
                  can be found in our Privacy Policy.
                </p>
              </section>
              <section data-id="element-1067">
                <h2 className="text-xl font-semibold mb-3 text-[#2E6BFF]" data-id="element-1068">
                  Your Use of the Services
                </h2>
                <p className="mb-3" data-id="element-1069">
                  You agree to use the Services only for lawful purposes and in
                  compliance with all applicable laws and regulations. You agree
                  not to use the Services to upload, store, or share any content
                  that is illegal, infringing, or harmful to others. This
                  includes, but is not limited to, content that is copyrighted,
                  trademarked, defamatory, pornographic, or hate speech.
                </p>
                <p className="mb-3" data-id="element-1070">
                  You may not use the Services to upload, store, or share any
                  content that contains malware or other harmful code. You may
                  not use the Services to engage in any activity that interferes
                  with or disrupts the Services or servers or networks connected
                  to the Services.
                </p>
                <p className="mb-3" data-id="element-1071">
                  You are responsible for all content that you upload, store, or
                  share through the Services. You represent and warrant that you
                  have all necessary rights and licenses to upload, store, or
                  share any content that you upload, store, or share through the
                  Services.
                </p>
                <p data-id="element-1072">
                  You acknowledge that Pigeon Documents has no obligation to
                  monitor the content that you upload, store, or share through
                  the Services, but that we have the right to do so for the
                  purpose of enforcing these Terms, complying with legal
                  obligations, or protecting the rights, property, or safety of
                  Pigeon Documents, our users, or others.
                </p>
              </section>
              <section data-id="element-1073">
                <h2 className="text-xl font-semibold mb-3 text-[#2E6BFF]" data-id="element-1074">
                  Termination
                </h2>
                <p className="mb-3" data-id="element-1075">
                  We may terminate your account or your access to the Services
                  at any time and for any reason, including for violation of
                  these Terms or for any other reason in our sole discretion. We
                  may also terminate your account or access to the Services if
                  you fail to use the Services for an extended period of time.
                </p>
                <p data-id="element-1076">
                  We will not be liable to you or any third party for any
                  termination of your account or your access to the Services.
                </p>
              </section>
              <section data-id="element-1077">
                <h2 className="text-xl font-semibold mb-3 text-[#2E6BFF]" data-id="element-1078">
                  Ownership and Intellectual Property
                </h2>
                <p data-id="element-1079">
                  The Services and all content and materials included on the
                  Services, including but not limited to text, graphics, logos,
                  images, and software, are the property of Pigeon Documents or
                  its licensors and are protected by United States and
                  international copyright and trademark laws. You may not use
                  any content or materials on the Services for any commercial
                  purpose without our express written consent.
                </p>
              </section>
              <section data-id="element-1080">
                <h2 className="text-xl font-semibold mb-3 text-[#2E6BFF]" data-id="element-1081">
                  Modification and Discontinuation
                </h2>
                <p data-id="element-1082">
                  We reserve the right to modify or discontinue the Services at
                  any time and without notice. We will not be liable to you or
                  any third party for any modification or discontinuation of the
                  Services.
                </p>
              </section>
              <section data-id="element-1083">
                <h2 className="text-xl font-semibold mb-3 text-[#2E6BFF]" data-id="element-1084">
                  Warranty Disclaimer
                </h2>
                <p data-id="element-1085">THE SERVICES ARE PROVIDED "AS IS" AND "AS AVAILABLE"</p>
              </section>
            </div>
          </motion.div>
        </div>
      </main>
      <Footer data-id="element-1086" />
    </div>;
};